import { defineComponent as _defineComponent } from 'vue'
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import { computed } from 'vue';
import BCXTable from '@/components/BCXTable.vue';
import useI18n from '@/mixins/useI18n';
import { ProjectWithOffers } from '@/models/MyProjects';
import { getRouteForProjectId } from '@/views/my-projects/utils/utils';
import { BcxTableFilter } from '@/models/BcxTable';
import { projectSortFieldValue, searchCallback, filter as defaultFilter } from '@/views/my-projects/components/overview/searchFilterSortFunctions';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsOverviewTable',
  setup(__props) {

const {
  receivedProjectsWithOffers,
  isNarrow,
  projectIdsToKeepInProjectFilter,
  visibleReceivedProjectsWithOffers
} = useMyProjects();

const { getFormattedDate } = useFormattedDateTime();
const { t } = useI18n();

const isOfferRead = (lastUpdated: string, read?: string) => {
  if (!read) return false;

  const readDate = new Date(read);
  return readDate > new Date(lastUpdated);
};

const projectsWithRead = computed(() => receivedProjectsWithOffers.value.map((project) => {
  const read = project.offers.every((offer) => isOfferRead(offer.lastUpdated, offer.read));
  return {
    ...project,
    read
  };
}));

const fieldNames = ['created', 'title', 'offers', 'latest'];
const headerTitles = computed(() => [
  t('my-projects.overview.columns.created'),
  t('my-projects.overview.columns.title'),
  t('my-projects.overview.columns.offers'),
  t('my-projects.overview.columns.latest')
]);

const projectFieldValue = (fieldName: string, obj: ProjectWithOffers): string => {
  const value = projectSortFieldValue(fieldName, obj);
  return fieldName === 'created' || fieldName === 'latest' ? getFormattedDate(value) : value;
};

const filter = computed(():BcxTableFilter => ({
  ...defaultFilter,
  labelCallback: (state: string) => `${t(`my-projects.overview.filters.${state}`)}`,
  stateCallback: (states: string[], obj: ProjectWithOffers) => {
    if (projectIdsToKeepInProjectFilter.value.includes(obj.project.id)) return true;
    const filterState = obj.project.status === 'ACTIVE' ? 'ACTIVE' : 'CLOSED';
    return states.includes(filterState);
  }
}));


return { __sfc: true,receivedProjectsWithOffers, isNarrow, projectIdsToKeepInProjectFilter, visibleReceivedProjectsWithOffers, getFormattedDate, t, isOfferRead, projectsWithRead, fieldNames, headerTitles, projectFieldValue, filter, BCXTable, getRouteForProjectId, projectSortFieldValue }
}

})